// extracted by mini-css-extract-plugin
export default {"statusBadge":"styles_statusBadge__p4DsK","statusContainer":"styles_statusContainer__sf44n"};